export enum ManagedModalRoutes {
  ENTRY_MANAGED = 'entry-managed',
  LOCALIZED_ORDER = 'localized-order',
  LOCALIZED_BUDGET_ORDER = 'localized-budget-order',
  ORDER_ALREADY_ASSOCIATED = 'order-already-associated',
  ORDER_PERSONAL_DATA = 'order-personal-data',
  SHIPPING_CLIENT_MANAGED = 'shipping-client-managed',
  CONFIRMED_CUSTOMER_SHIPMENT = 'confirmed-customer-shipment',
  SHIPPING_FINISHED_MANAGED = 'shipping-finished-managed',
  DniSCAN_MANAGED = 'dniscanned-managed',
  // retake
  CUSTOMER_ACCESS = 'customer-access',
  UNKNOWN_ERROR = 'unknown-error',
  DENIAL = 'denial',
  TIMEOUT = 'timeout',
}
